export const MossLogo = ({color = '#FFF', style}: {color?: string; style?: React.CSSProperties}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="22" viewBox="0 0 27 22" fill="none" style={style}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2737 2.48697C19.3399 1.21133 20.7894 0.413574 22.6704 0.413574H25.8128C25.9421 0.413574 26.0469 0.518378 26.0469 0.64766V15.0356C26.0469 18.6309 23.1323 21.5455 19.5369 21.5455H16.3945C16.2653 21.5455 16.1605 21.4407 16.1605 21.3114V19.6259C16.1605 19.5723 16.0938 19.5466 16.0571 19.5857C14.9202 20.7946 13.343 21.5457 11.4882 21.5457H8.91112C8.78184 21.5457 8.67703 21.4409 8.67703 21.3116V19.6768C8.67703 19.6235 8.61109 19.5976 8.57412 19.6361C7.44105 20.8152 5.88222 21.5454 4.0535 21.5454H1.18721C1.05793 21.5454 0.953125 21.4406 0.953125 21.3113V11.5915C0.953125 7.99617 3.86773 5.08157 7.46308 5.08157H10.4318C11.4192 3.50571 13.0614 2.48697 15.187 2.48697H18.2737ZM22.6704 2.75443H23.8231V15.0356C23.8231 17.3381 21.8395 19.2047 19.5369 19.2047H18.5013V6.92353C18.5013 4.621 20.3679 2.75443 22.6704 2.75443ZM16.2394 4.82782H15.187C12.8845 4.82782 11.0179 6.69439 11.0179 8.99693V19.2048H11.4882C14.0476 19.2048 16.2394 17.1301 16.2394 14.5707V4.82782ZM8.80464 7.42242H7.46308C5.16055 7.42242 3.29398 9.28899 3.29398 11.5915V19.2045H4.0535C6.61285 19.2045 8.80464 17.1298 8.80464 14.5704V7.42242Z"
      fill={color}
    />
  </svg>
)

export const Card = ({color = '#B9FF3F'}: {color?: string}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.12053 4.80002H18.8842C20.6696 4.80002 22.1023 6.25205 22.1023 8.02502L22.1023 9.60002H2.90234V8.02502C2.90234 6.25205 4.33504 4.80002 6.12053 4.80002Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.90234 11.7V16.575C2.90234 18.348 4.33504 19.8 6.12053 19.8H18.8842C20.6696 19.8 22.1023 18.348 22.1023 16.575L22.1023 11.7H2.90234Z"
      fill={color}
    />
  </svg>
)

export const Reimbursements = ({color = '#B9FF3F'}: {color?: string}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.8363 7.20001V4.80001C18.8363 4.13726 18.2991 3.60001 17.6363 3.60001H5.93633C4.44516 3.60001 3.23633 4.80884 3.23633 6.30001V16.8C3.23633 18.7882 4.8481 20.4 6.83633 20.4H21.2363C21.8991 20.4 22.4363 19.8627 22.4363 19.2V8.40001C22.4363 7.73726 21.8991 7.20001 21.2363 7.20001H18.8363ZM17.0363 5.40001H5.93633C5.43927 5.40001 5.03633 5.80295 5.03633 6.30001C5.03633 6.79706 5.43927 7.20001 5.93633 7.20001H17.0363V5.40001ZM18.2363 13.8C18.2363 14.7941 17.4304 15.6 16.4363 15.6C15.4422 15.6 14.6363 14.7941 14.6363 13.8C14.6363 12.8059 15.4422 12 16.4363 12C17.4304 12 18.2363 12.8059 18.2363 13.8Z"
      fill={color}
    />
  </svg>
)

export const AccountsPayable = ({color = '#B9FF3F'}: {color?: string}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M3.16719 5.40002C2.17307 5.40002 1.36719 6.20591 1.36719 7.20002V16.8C1.36719 17.7941 2.17307 18.6 3.16719 18.6H21.1672C22.1613 18.6 22.9672 17.7941 22.9672 16.8V7.20002C22.9672 6.20591 22.1613 5.40002 21.1672 5.40002H3.16719ZM12.1672 15C10.5103 15 9.16719 13.6569 9.16719 12C9.16719 10.3432 10.5103 9.00002 12.1672 9.00002C13.824 9.00002 15.1672 10.3432 15.1672 12C15.1672 13.6569 13.824 15 12.1672 15Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.16719 7.20002V16.8H12.1672H21.1672V7.20002H12.1672L3.16719 7.20002ZM12.1672 7.20002C14.8182 7.20002 16.9672 9.34906 16.9672 12C16.9672 14.651 14.8182 16.8 12.1672 16.8C9.51622 16.8 7.36719 14.651 7.36719 12C7.36719 9.34906 9.51622 7.20002 12.1672 7.20002ZM1.36719 7.20002C1.36719 6.20591 2.17307 5.40002 3.16719 5.40002H21.1672C22.1613 5.40002 22.9672 6.20591 22.9672 7.20002V16.8C22.9672 17.7941 22.1613 18.6 21.1672 18.6H3.16719C2.17307 18.6 1.36719 17.7941 1.36719 16.8V7.20002ZM9.16719 12C9.16719 13.6569 10.5103 15 12.1672 15C13.824 15 15.1672 13.6569 15.1672 12C15.1672 10.3432 13.824 9.00002 12.1672 9.00002C10.5103 9.00002 9.16719 10.3432 9.16719 12Z"
      fill={color}
    />
  </svg>
)

export const Controlling = ({color = '#717171'}: {color?: string}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6973 3.3C20.5257 3.3 21.1973 3.97157 21.1973 4.8V17.1C21.1973 17.9284 20.5257 18.6 19.6973 18.6C18.8688 18.6 18.1973 17.9284 18.1973 17.1V4.8C18.1973 3.97157 18.8688 3.3 19.6973 3.3Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8973 9.08823C15.7257 9.08823 16.3973 9.7598 16.3973 10.5882V17.1C16.3973 17.9284 15.7257 18.6 14.8973 18.6C14.0688 18.6 13.3973 17.9284 13.3973 17.1V10.5882C13.3973 9.7598 14.0688 9.08823 14.8973 9.08823Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0973 3.3C10.9257 3.3 11.5973 3.97157 11.5973 4.8V17.1C11.5973 17.9284 10.9257 18.6 10.0973 18.6C9.26884 18.6 8.59727 17.9284 8.59727 17.1V4.8C8.59727 3.97157 9.26884 3.3 10.0973 3.3Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.29727 9.08823C6.12569 9.08823 6.79727 9.7598 6.79727 10.5882V17.1C6.79727 17.9284 6.12569 18.6 5.29727 18.6C4.46884 18.6 3.79727 17.9284 3.79727 17.1V10.5882C3.79727 9.7598 4.46884 9.08823 5.29727 9.08823Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.19727 20.7C3.19727 20.2029 3.60021 19.8 4.09727 19.8H20.8973C21.3943 19.8 21.7973 20.2029 21.7973 20.7C21.7973 21.1971 21.3943 21.6 20.8973 21.6H4.09727C3.60021 21.6 3.19727 21.1971 3.19727 20.7Z"
      fill={color}
    />
  </svg>
)

export const Procurement = ({color = '#717171'}: {color?: string}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00195 3.6C2.00195 3.10294 2.4049 2.7 2.90195 2.7H5.30195C5.73691 2.7 6.10963 3.01106 6.18744 3.439L6.65307 6H19.426C20.1873 6 20.7561 6.69965 20.6008 7.44485L19.3502 13.4449C19.2342 14.0013 18.7438 14.4 18.1755 14.4H8.18035L8.40828 15.6537C8.43422 15.7963 8.55846 15.9 8.70345 15.9H17.902C18.399 15.9 18.802 16.3029 18.802 16.8C18.802 17.2971 18.399 17.7 17.902 17.7H8.70345C7.68854 17.7 6.81887 16.9742 6.63732 15.9757L4.55084 4.5H2.90195C2.4049 4.5 2.00195 4.09705 2.00195 3.6Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.90195 19.8C8.90195 20.4627 8.3647 21 7.70195 21C7.03921 21 6.50195 20.4627 6.50195 19.8C6.50195 19.1373 7.03921 18.6 7.70195 18.6C8.3647 18.6 8.90195 19.1373 8.90195 19.8Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.302 21C17.9647 21 18.502 20.4627 18.502 19.8C18.502 19.1373 17.9647 18.6 17.302 18.6C16.6392 18.6 16.102 19.1373 16.102 19.8C16.102 20.4627 16.6392 21 17.302 21Z"
      fill={color}
    />
  </svg>
)

export const Erp = ({color = '#717171'}: {color?: string}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4996 21.6C7.19767 21.6 2.8996 17.302 2.8996 12C2.8996 6.69807 7.19767 2.39999 12.4996 2.39999C17.8015 2.39999 22.0996 6.69807 22.0996 12C22.0996 17.302 17.8015 21.6 12.4996 21.6ZM12.499 6.55736C11.8362 6.55736 11.299 7.09462 11.299 7.75737V10.8L8.25696 10.8C7.59422 10.8 7.05696 11.3372 7.05696 12C7.05696 12.6627 7.59422 13.2 8.25696 13.2L11.299 13.2V16.2427C11.299 16.9054 11.8362 17.4427 12.499 17.4427C13.1617 17.4427 13.699 16.9054 13.699 16.2427V13.2H16.7422C17.405 13.2 17.9422 12.6627 17.9422 12C17.9422 11.3372 17.405 10.8 16.7422 10.8H13.699V7.75737C13.699 7.09462 13.1617 6.55736 12.499 6.55736Z"
      fill={color}
    />
  </svg>
)

export const Accounting = ({color = '#717171'}: {color?: string}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50156 3.9C4.00451 3.9 3.60156 4.30295 3.60156 4.8V16.8C3.60156 17.2971 4.00451 17.7 4.50156 17.7H10.1016C10.4994 17.7 10.8809 17.858 11.1622 18.1393C11.4407 18.4178 11.5984 18.7945 11.6015 19.188V19.2C11.6015 19.6427 11.9212 20.0107 12.3422 20.0859C12.3939 20.0952 12.4472 20.1 12.5015 20.1C12.5015 20.1 12.5015 20.1 12.5015 20.1C12.9986 20.1 13.4016 19.6971 13.4016 19.2V19.188C13.4047 18.7945 13.5624 18.4178 13.8409 18.1393C14.1222 17.858 14.5037 17.7 14.9015 17.7H20.5015C20.9986 17.7 21.4015 17.2971 21.4015 16.8V4.8C21.4015 4.30295 20.9986 3.9 20.5015 3.9H15.7015C14.6141 3.9 13.5713 4.33196 12.8024 5.10086C12.6955 5.20774 12.5951 5.3199 12.5015 5.43675C12.4079 5.3199 12.3076 5.20774 12.2007 5.10086C11.4318 4.33196 10.389 3.9 9.30156 3.9H4.50156Z"
      fill={color}
    />
  </svg>
)
